<style>
.responseBox {
  align-items: center;
  justify-content: center;
  padding: 2%;
  max-width: 50%;
  text-align: center;
}
.successBox {
  background-color: #073763;
}
.errorBox {
  background-color: red;
}
.responseBox p {
  color: white;
  margin-bottom: 0;
  margin-top: 20px;
}
</style>
<template>
  <div id="main-wrapper">
    <div
      class="content-container dashboard-page"
      style="
        min-height: 500px;
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <p v-if="response == -1">{{$t('account.verifying_your_request')}}</p>
      <div class="responseBox successBox" v-if="response == 1">
        <h3>{{$t('account.success')}}</h3>
        <p>{{ msg }}</p>
      </div>
      <div class="responseBox errorBox" v-if="response == 0">
        <h3>{{$t('account.error')}}</h3>
        <p>{{ msg }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      response: -1,
      msg: null,
      type: null,
      verify: null,
    };
  },
  mounted() {
    if (this.$route.query.verify) {
      this.verify = this.$route.query.verify;
      this.type = this.$route.query.type;
      this.$router.replace("/account-verify");
      this.start();
    } else {
      this.$router.push("/dashboard");
    }
  },
  methods: {
    start() {
      let formJson = {
        type: this.type,
        verify: this.verify,
      };
      if(this.type == 'WEB_ACCOUNT_CHANGE PASSWORD'){
        formJson.type = 'MASTER'
      }else if(this.type == 'TRADING_ACCOUNT_CHANGE PASSWORD'){
        formJson.type = 'INVESTOR'
      }
      this.store
        .verifyAccountOperation(formJson, true)
        .then((response) => {
          this.response = 1;
          if (this.type == "INTERNAL TRANSFER") {
            this.msg = `Your internal transfer request from account ${
              response.account_id
            } for amount ${this.static_vars.currency[response.currency]}${
              response.amount
            } to account ${
              response.to_account_id
            }  was succesfull with an amount of ${
              this.static_vars.currency[response.to_currency]
            }${response.to_amount}.`;
          } else if (this.type == "CHANGE LEVERAGE") {
            this.msg = `Change leverage request processed successfully`;
          } else if (this.type == "CHANGE PASSWORD") {
            this.msg = `Change password request processed successfully`;
          } else if (this.type == "BONUS") {
            this.msg = `Add bonus request processed successfully`;
          } else if (this.type == "REMOVE_BONUS") {
            this.msg = `Remove bonus request processed successfully`;
          } else if(this.type == "WEB_ACCOUNT_CHANGE PASSWORD"){
            this.msg = `Change master password successfully`
          } else if(this.type == "TRADING_ACCOUNT_CHANGE PASSWORD"){
            this.msg = `Change investor password successfully`
          } else if(this.type == "DISABLE ACCOUNT"){
            this.msg = `Your Account has been deleted successfully`
            this.store.getTradingAccounts();
          }
        })
        .catch((error) => {
          this.response = 0;
          this.msg = error;
        });
    },
  },
};
</script>
